__turbopack_context__.v({
  "className": "dm_sans_6ed5732b-module__j7Wbiq__className",
  "variable": "dm_sans_6ed5732b-module__j7Wbiq__variable",
});
